import { Collection } from 'modules/core/lib/mobx-rest'

import Shift from 'modules/attendance/store/models/Shift'

class Shifts extends Collection<Shift> {
  get cacheKey(): string {
    return 'attendanceShifts'
  }

  model() {
    return Shift
  }

  get indexes() {
    return ['day', 'date', 'period_id', 'workable', 'automatic_clock_in', 'reference_date']
  }
}

const singleton: Shifts = new Shifts()

export default singleton
